import Save from "../../images/Save.svg";
import Update from "../../images/Edit.svg";
import Add from "../../images/Add.svg";
import Delete from "../../images/Delete.svg";
import Cancel from "../../images/Cancel.svg";
import Assign from "../../images/Assign.svg";
import View from "../../images/View.svg";
import Verify from "../../images/Validate.svg";
import ReAssign from "../../images/ReOrder.svg";
import Print from "../../images/PrintProgressCard.svg";
import Finalize from "../../images/Finalize.svg";
import Previous from "../../images/Previous.svg";
import Next from "../../images/Next.svg";
import WakeUp from "../../images/WakeUp.svg";
import Return from "../../images/Return.svg";
import Reopen from "../../images/ReOpen Ticket.svg";
import CloseTicket from "../../images/Close Ticket.svg";
// import ReOrder from "../../images/ReOrder.svg";
// import Skip from "../../images/Skip.svg";
import Clear from "../../images/Clear.svg";
// import Active from "../../images/Active.svg";
// import Fetch from "../../images/Fetch.svg";
// import Insert from "../../images/Insert.svg";
// import Generate from "../../images/Generate.svg";
// import Received from "../../images/Received.svg";
// import Pending from "../../images/PendingDemand.svg";
// import Transfer from "../../images/TransferAmount.svg";
// import Rewrite from "../../images/ReWriteDemand.svg";
// import PermissionLetter from "../../images/PermissionLetter.svg";
// import LogSheet from "../../images/LogSheet.svg";
import No from "../../images/Cancel.svg";
import Yes from "../../images/Yes.svg";
// import viewgraph from "../../images/ViewGraphically.svg";

// import AllTransaction from "../../images/AllTransaction.svg";
// import ReConcile from "../../images/ReConcile.svg";

// import CopyDemand from "../../images/CopyDemand.svg";
// import Collected from "../../images/Collected.svg";
import Excel from "../../images/Excel.svg";
// import DayEnd from "../../images/DayEnd.svg";
// import BookIssue from "../../images/BookIssue.svg";
// import BookReturn from "../../images/BookReturn.svg";
// import BookReservation from "../../images/BookReserve.svg";
// import BookRenewal from "../../images/BookRenewal.svg";
// import Preview from "../../images/Eye.svg";
// import Upload from "../../images/Upload.svg";
// import WaiveOff from "../../images/WaiveOff.svg";
// import AddNewFee from "../../images/AddNewFee.svg";
// import MoveTo from "../../images/Transfer.svg";
import Configure from "../../images/Configure.svg";
// import CashReceipts from "../../images/CashReceipts.svg";
// import AdjustmentReceipts from "../../images/AdjustmentReceipts.svg";
// import BankReceipts from "../../images/BankReceipts.svg";
import Okay from "../../images/Okay.svg";
// import RaiseStudentDemand from "../../images/RaiseStudentDemand.svg";
// import ExtendCalendar from "../../images/ExtendCalendar.svg";
// import Reset from "../../images/Reset.svg";
// import Recalculate from "../../images/ReCalculate.svg";
// import Absent from "../../images/AbsentList.svg";
// import Select from "../../images/Select.svg";
// import PayOnline from "../../images/PayOnline.svg";
// import UserRights from "../../images/User_Rights.svg";
// import DownloadPdf from "../../images/DownloadPdf.svg";
// import TransferReceipt from "../../images/TransferReceipt.svg";
import Approve from "../../images/Approve.svg";
// import Forward from "../../images/Forward.svg";
import Reject from "../../images/Rejected.svg";
import Loading from "../../images/Loading.gif";
import Choose from "../../images/Choose.svg";

// import PayFee from "../../images/ProceedToPay.svg";
// import Grade from "../../images/Grade.svg";
// import Selected from "../../images/Collected.svg";
// import Send from "../../images/Send.svg";
// import Message from "../../images/Chat.svg";
// import useUserRightsByEmpId from "../../Modules/UserRights/hooks/useUserRightsByEmpId";
// import { useContext } from "react";
// import { AppContext } from "../../context/context";

interface ButtonProps {
  autoFocus?: boolean;
  primary?: boolean;
  secondary?: boolean;

  backgroundColor?: string;

  mode?:
    | "addnew"
    | "create"
    | "choose"
    | "apply"
    | "cancel"
    | "back"
    | "edit"
    | "view"
    | "clear"
    | "demand"
    | "print"
    | "save"
    | "reorder"
    | "skip"
    | "ledger"
    | "finalize"
    | "raise"
    | "retire"
    | "wake-up"
    | "return"
    | "close-ticket"
    | "re-open"
    | "account-ledger"
    | "delete"
    | "re-assign"
    | "update"
    | "save-continue"
    | "finish"
    | "active"
    | "save-order"
    | "fetch"
    | "insert"
    | "yes"
    | "no"
    | "verify"
    | "generate"
    | "received"
    | "pending"
    | "previous-receipt"
    | "transfer"
    | "passout-students"
    | "rewrite-demand"
    | "statement"
    | "demand-details"
    | "permission"
    | "log-sheet"
    | "re-concile"
    | "submit"
    | "pre-defined"
    | "page-config"
    | "copy-demand"
    | "copy-test"
    | "copy"
    | "move"
    | "predefined-type"
    | "default"
    | "ledger-report"
    | "collection-report"
    | "excel"
    | "day-end"
    | "issue-book"
    | "return-book"
    | "reserve-book"
    | "renewal-book"
    | "sign-in"
    | "sign-out"
    | "continue"
    | "make-elligible"
    | "preview"
    | "upload"
    | "collect-fine"
    | "waive-off"
    | "add-new-fee"
    | "all-transaction"
    | "configure"
    | "show-summarized"
    | "all-receipts"
    | "cash-receipts"
    | "bank-receipts"
    | "adjustment-receipts"
    | "okay"
    | "extend"
    | "approve"
    | "forward"
    | "reject"
    | "reset"
    | "re-calculate"
    | "export"
    | "view-graph"
    | "absent"
    | "update-continue"
    | "continue"
    | "select"
    | "pay-online"
    | "remove"
    | "user-rights"
    | "assign-salary-structure"
    | "assign"
    | "previous"
    | "pdf"
    | "move-next"
    | "move-to"
    | "transfer-receipt"
    | "allocate"
    | "otp"
    | "proceed"
    | "pay-fee"
    | "start-posting"
    | "add-depositledgers"
    | "add-doctype"
    | "fill-diary"
    | "next"
    | "grade"
    | "pay-only-ob"
    | "pay-newdemand-also"
    | "fee-details"
    | "close"
    | "docs-upload"
    | "docs-download"
    | "docs-delete"
    | "send"
    | "selected"
    | "message"
    | "assigned"
    | "reassign"
    | "not-an-issue"
    | "resolve"
    | "update";

  /**
   * Button contents
   */
  label?: string;
  /**
   * Optional click handler
   */
  onClick?: any;

  disabled?: boolean;
  type?: "submit" | "reset" | "button" | undefined;
  children?: any;
  onKeyDown?: any;
  className?: String;
  buttonref?: React.LegacyRef<HTMLButtonElement> | undefined;
  loading?: boolean;
}

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  mode = "default",
  onClick,
  children,
  onKeyDown,
  autoFocus,
  type,
  disabled,
  className,
  buttonref,
  loading,
}: ButtonProps) => {
  // const {
  //   // USE_ACADEMICS,
  //   USE_ACCOUNTS,
  //   USE_ENQUIRY,
  //   USE_LIBRARY,
  //   // USE_MESSAGE_APP,
  //   USE_PAYROLL,
  //   USE_ADMISSIONS,
  //   // USE_TRANSPORT,
  // } = useUserRightsByEmpId();
  // const { state } = useContext(AppContext);

  // const hanldeButtonDisable = () => {
  //   const modules = [
  //     USE_ACCOUNTS,
  //     USE_LIBRARY,
  //     USE_ACADEMICS,
  //     USE_ENQUIRY,
  //     USE_PAYROLL,
  //     USE_TRANSPORT,
  //     USE_MESSAGE_APP,
  //   ];
  //   let bool = false;
  //   for (const module of modules) {
  //     bool = module.flag;
  //     if (bool && state.claims?.EMPLOYEE) {
  //       const { view, add, delete: Delete, edit } = module.details || {};

  //       switch (mode) {
  //         case "view":
  //           return view === false;
  //         case "addnew":
  //         case "save":
  //           return add === false;
  //         case "upload":
  //         case "save-order":
  //
  //           return add === false;
  //         case "delete":
  //           return Delete === false;
  //         case "edit":
  //           return !(edit );
  //         default:
  //           return false;
  //       }
  //     }
  //     bool = false;
  //   }
  // };

  // const hanldeButtonDisable = () => {
  //   if (USE_ACCOUNTS.flag && window.location.pathname.includes("/accounts")) {
  //     const { view, add, delete: Delete, edit } = USE_ACCOUNTS.details || {};

  //     switch (mode) {
  //       case "view":
  //         return view === false;
  //       case "addnew":
  //       case "upload":
  //       case "save-order":
  //       case "pay-only-ob":
  //       case "pay-newdemand-also":
  //         return add === false;
  //       case "save":
  //         return add === false;
  //       case "delete":
  //         return Delete === false;
  //       case "edit":
  //         return edit === false;
  //       case "add-depositledgers":
  //         return add === false;
  //       default:
  //         return false;
  //     }
  //   } else if (
  //     USE_LIBRARY.flag &&
  //     window.location.pathname.includes("/library")
  //   ) {
  //     const { view, add, delete: Delete, edit } = USE_LIBRARY.details || {};

  //     switch (mode) {
  //       case "view":
  //         return view === false;
  //       case "addnew":
  //       case "issue-book":
  //       case "return-book":
  //       case "renewal-book":
  //         return add === false;
  //       case "delete":
  //         return Delete === false;
  //       case "edit":
  //         return edit === false;
  //       case "save":
  //         return edit || add ? false : true;
  //       default:
  //         return false;
  //     }
  //   } else if (
  //     USE_ENQUIRY.flag &&
  //     window.location.pathname.includes("/enquiry")
  //   ) {
  //     const { view, add, delete: Delete, edit } = USE_ENQUIRY.details || {};
  //     switch (mode) {
  //       case "view":
  //         return view === false;
  //       case "addnew":
  //       case "upload":
  //       case "save-order":
  //         return add === false;
  //       case "save":
  //         if (window.location.pathname.includes("/enquiry/followup"))
  //           return edit ? false : true;
  //         return add === false;

  //       case "delete":
  //         return Delete === false;
  //       case "edit":
  //         return edit === false;

  //       default:
  //         return false;
  //     }
  //   } else if (USE_PAYROLL.flag && window.location.pathname.includes("/hr")) {
  //     const { view, add, delete: Delete, edit } = USE_PAYROLL.details || {};
  //     switch (mode) {
  //       case "view":
  //         return view === false;
  //       case "addnew":
  //       case "upload":
  //       case "save-order":
  //         return add === false;
  //       case "save":
  //         return add === false;

  //       case "delete":
  //         return Delete === false;
  //       case "edit":
  //       case "update":
  //       case "update-continue":
  //       case "assign-salary-structure":
  //         return edit === false;

  //       default:
  //         return false;
  //     }
  //   } else if (
  //     USE_ADMISSIONS.flag &&
  //     window.location.pathname.includes("/admissions")
  //   ) {
  //     const { view, add, delete: Delete, edit } = USE_ADMISSIONS.details || {};
  //     switch (mode) {
  //       case "view":
  //       case "docs-download":
  //         return view === false;
  //       case "addnew":
  //       case "upload":
  //       case "save-order":
  //       case "docs-upload":
  //         return add === false;
  //       case "save":
  //       case "active":
  //       case "reorder":
  //         return add === false;

  //       case "delete":
  //       case "docs-delete":
  //         return Delete === false;
  //       case "edit":
  //       case "update":
  //       case "update-continue":
  //       case "assign-salary-structure":
  //       case "add-doctype":
  //         return edit === false;

  //       default:
  //         return false;
  //     }
  //   }
  // };

  return (
    <button
      disabled={
        disabled || loading
        // || hanldeButtonDisable()
      }
      type={type}
      autoFocus={autoFocus}
      onClick={onClick}
      ref={buttonref!}
      className={[
        "storybook-button",
        `storybook-button--${mode}`,
        className,
      ].join(" ")}
      onKeyDown={onKeyDown}
    >
      {loading ? <img src={Loading} alt="/" /> : null}

      {mode && mode === "save" ? (
        <>
          {loading ? null : <img src={Save} alt="/" />}
          Save
        </>
      ) : mode === "sign-in" ? (
        <>Login {loading ? null : <img src={Assign} alt="" />}</>
      ) : mode === "continue" ? (
        <>Continue {loading ? null : <img src={Assign} alt="" />}</>
      ) : mode === "proceed" ? (
        <>proceed {loading ? null : <img src={Assign} alt="" />}</>
      ) : mode === "edit" ? (
        <>
          {loading ? null : <img src={Update} alt="/" />}
          Edit
        </>
      ) : mode === "back" ? (
        <>
          {loading ? null : <img src={Previous} alt="/" />}
          Back
        </>
      ) : mode === "clear" ? (
        <>
          {loading ? null : <img src={Clear} alt="/" />}
          Clear
        </>
      ) : mode === "addnew" ? (
        <>
          {loading ? null : <img src={Add} alt="/" />}
          Add
        </>
      ) : mode === "choose" ? (
        <>
          {loading ? null : <img src={Choose} alt="/" />}
          Choose
        </>
      ) : mode === "save-continue" ? (
        <>
          {loading ? null : <img src={Save} alt="/" />}
          Save & Continue
        </>
      ) : mode === "delete" ? (
        <>
          {loading ? null : <img src={Delete} alt="/" />}
          Delete
        </>
      ) : mode === "cancel" ? (
        <>
          {loading ? null : <img src={Cancel} alt="/" />}
          Cancel
        </>
      ) : mode === "move-next" ? (
        <>
          Move Next &nbsp;
          {loading ? null : <img src={Next} alt="/" />}
        </>
      ) : mode === "move-to" ? (
        <>
          Move To &nbsp;
          {loading ? null : <img src={Next} alt="/" />}
        </>
      ): mode === "close-ticket" ? (
        <>
          {loading ? null : <img src={CloseTicket} alt="/" />}
          &nbsp;Close Ticket
        </>
      ) : mode === "re-open" ? (
        <>
          {loading ? null : <img src={Reopen} alt="/" />}
          &nbsp;Re-Open Ticket
        </>
      ) : mode === "assigned" ? (
        <>
          {loading ? null : <img src={Yes} alt="/" />}
          &nbsp; Assign
        </>
      ) : mode === "reassign" ? (
        <>
          {loading ? null : <img src={Yes} alt="/" />}
          &nbsp; Re Assign
        </>
      ) : mode === "not-an-issue" ? (
        <>
          {loading ? null : <img src={Cancel} alt="/" />}
          &nbsp; Not An Issue
        </>
      ) : mode === "resolve" ? (
        <>
          {loading ? null : <img src={Yes} alt="/" />}
          &nbsp; Resolve
        </>
      ) : mode === "update" ? (
        <>
          {loading ? null : <img src={Update} alt="/" />}
          &nbsp; update
        </>
      ) : mode === "sign-out" ? (
        <>Log Out</>
      ) : mode && mode === "assign" ? (
        <>
          {loading ? null : <img src={Assign} alt="/" />}
          Assign
        </>
      ) : mode === "approve" ? (
        <>
          {loading ? null : <img src={Approve} alt="/" />}
          Approve
        </>
      ) : mode === "reject" ? (
        <>
          {loading ? null : <img src={Reject} alt="/" />}
          Reject
        </>
      ) : mode && mode === "apply" ? (
        <>
          {loading ? null : <img src={Assign} alt="/" />}
          Apply
        </>
      ) : mode === "predefined-type" ? (
        <>{loading ? null : <img src={Add} alt="/" />} Add Predefined Type</>
      ) : mode === "okay" ? (
        <>
          {loading ? null : <img src={Okay} alt="/" />}
          Okay
        </>
      ) : mode === "finalize" ? (
        <>
          {loading ? null : <img src={Finalize} alt="/" />} Finalize and Submit
          Quotation
        </>
      ) : mode === "view" ? (
        <>
          {loading ? null : <img src={View} alt="/" />}
          View
        </>
      ) : mode && mode === "configure" ? (
        <>
          {loading ? null : <img src={Configure} alt="/" />}
          Configuration
        </>
      ) : mode === "excel" ? (
        loading ? (
          <></>
        ) : (
          <img src={Excel} alt="/" />
        )
      ) : mode && mode === "export" ? (
        <>
          {loading ? null : <img src={Excel} alt="/" />}
          Export
        </>
      ) : mode === "raise" ? (
        <>{loading ? null : <img src={Finalize} alt="/" />} Raise</>
      ) : mode === "retire" ? (
        <>{loading ? null : <img src={Finalize} alt="/" />} Retire</>
      ) : mode === "wake-up" ? (
        <>{loading ? null : <img src={WakeUp} alt="/" />} Wake Up</>
      ) : mode === "return" ? (
        <>{loading ? null : <img src={Return} alt="/" />} Return</>
      ) : mode === "yes" ? (
        <>
          {loading ? null : <img src={Yes} alt="/" />}
          Yes
        </>
      ) : mode === "verify" ? (
        <>
          {loading ? null : <img src={Verify} alt="/" />}
          Verified
        </>
      ) : mode === "no" ? (
        <>
          {loading ? null : <img src={No} alt="/" />}
          No
        </>
      ) : mode === "print" ? (
        <>
          {loading ? null : <img src={Print} alt="/" />}
          Print
        </>
      ) : mode === "re-assign" ? (
        <>
          {loading ? null : <img src={ReAssign} alt="/" />}
          Re - Assign
        </>
      ) : null}
      {/* ) : mode === "message" ? (
        <>
          { loading ? null : <img src={Message} alt="/" />}
          Message
        </>
      ) : mode === "send" ? (
        <>
          { loading ? null : <img src={Send} alt="/" />}
          Send Message
        </>
      ) : mode === "selected" ? (
        <>
          { loading ? null : <img src={Selected} alt="/" />}
          Select Multiple Students
        </>
      ) : mode === "addnew" ? (
        <>
          { loading ? null : <img src={Add} alt="/" />}
          Add
        </>
      ) : mode === "create" ? (
        <>
          { loading ? null : <img src={Add} alt="/" />}
          Create
        </>
      ) : mode === "otp" ? (
        <>
          { loading ? null : <img src={Add} alt="/" />}
          Request OTP
        </>
      ) : mode === "clear" ? (
        <>
          { loading ? null : <img src={Clear} alt="/" />}
          Clear
        </>
      ) 
      ) : mode === "skip" ? (
        <>
          { loading ? null : <img src={Skip} alt="/" />}
          Skip
        </>
      )  : mode === "reorder" ? (
        <>
          { loading ? null : <img src={ReOrder} alt="/" />}
          ReOrder
        </>
      )   : mode === "fill-diary" ? (
        <>
          { loading ? null : <img src={Assign} alt="/" />}
          Fill the Diary
        </>
      ) : mode === "remove" ? (
        <>
          { loading ? null : <img src={Cancel} alt="/" />}
          Remove
        </>
      ) : mode === "fee-details" ? (
        <>
          { loading ? null : <img src={View} alt="/" />}
          Fee Details
        </>
      ) : mode === "update-continue" ? (
        <>
          { loading ? null : <img src={Update} alt="/" />}
          Update & Continue
        </>
      ) : mode === "continue" ? (
        <>
          Continue
          { loading ? null : <img src={Assign} alt="/" />}
        </>
      ) : mode === "update" ? (
        <>
          { loading ? null : <img src={Update} alt="/" />}
          Update
        </>
      ) : mode === "save-continue" ? (
        <>
          { loading ? null : <img src={Save} alt="/" />}
          Save & Continue
        </>
      ) : mode === "select" ? (
        <>
          { loading ? null : <img src={Select} alt="/" />}
          Select
        </>
      ) : mode === "finish" ? (
        <>
          { loading ? null : <img src={View} alt="/" /> Finish}
        </>
      ) : mode === "active" ? (
        <>
          { loading ? null : <img src={Active} alt="/" />}
        </>
      ) : mode === "save-order" ? (
        <>
          { loading ? null : <img src={Save} alt="/" />}
          Save Order
        </>
      ) : mode === "ledger" ? (
        <>
          <>
            { loading ? null : <img src={Add} alt="/" />}
            Add Fee Ledger
          </>
        </>
      ) : mode === "account-ledger" ? (
        <>
          <>
            { loading ? null : <img src={Add} alt="/" />}
            Add Account Ledger
          </>
        </>
      ) : mode === "fetch" ? (
        <>
          { loading ? null : <img src={Fetch} alt="/" />}
          Fetch
        </>
      ) : mode === "demand" ? (
        <>
          { loading ? null : <img src={RaiseStudentDemand} alt="/" />}
          Raise Student Demand
        </>
      ) : mode === "insert" ? (
        <>
          { loading ? null : <img src={Insert} alt="/" />}
          Insert
        </>
      )  : mode === "generate" ? (
        <>
          { loading ? null : <img src={Generate} alt="/" />}
          Generate
        </>
      ) : mode === "received" ? (
        <>
          { loading ? null : <img src={Received} alt="/" />}
          Received
        </>
      ) : mode === "pending" ? (
        <>
          { loading ? null : <img src={Pending} alt="/" />}
          get All students
        </>
      ) : mode === "previous-receipt" ? (
        <>
          { loading ? null : <img src={Print} alt="/" />}
          Print Previous Receipt
        </>
      ) : mode === "transfer" ? (
        <>
          { loading ? null : <img src={Transfer} alt="/" /> Transfer}
        </>
      ) : mode === "transfer-receipt" ? (
        <>
          { loading ? null : <img src={TransferReceipt} alt="/" /> Transfer Receipt}
        </>
      ) : mode === "move-to" ? (
        <>
          { loading ? null : <img src={MoveTo} alt="/" /> Move to}
        </>
      ) : mode === "allocate" ? (
        <>
          { loading ? null : <img src={MoveTo} alt="/" /> Allocate to}
        </>
      ) : mode === "passout-students" ? (
        <>
          { loading ? null : <img src={Add} alt="/" /> Add Alumini Students}
        </>
      ) : mode === "rewrite-demand" ? (
        <>
          { loading ? null : <img src={Rewrite} alt="/" />}
          Re-Wrtie Demand
        </>
      ) : mode === "statement" ? (
        <>
          { loading ? null : <img src={Print} alt="/" />}
          Print A/C Statement
        </>
      ) : mode === "permission" ? (
        <>
          { loading ? null : <img src={PermissionLetter} alt="/" />}
          Permission Letter
        </>
      ) : mode === "demand-details" ? (
        <>
          { loading ? null : <img src={Print} alt="/" />}
          Print Demand Details
        </>
      ) : mode === "log-sheet" ? (
        <>
          { loading ? null : <img src={LogSheet} alt="/" />}
          Log Sheet
        </>
      ) : mode === "re-concile" ? (
        <>
          { loading ? null : <img src={ReConcile} alt="/" />}
          Auto ReConcil All Students Receipt
        </>
      ) : mode === "submit" ? (
        <>
          { loading ? null : <img src={Save} alt="/" />}
          Submit Details
        </>
      ) : mode === "pre-defined" ? (
        <>Pre Defined</>
      ) : mode === "page-config" ? (
        <>Page Configuration</>
      ) : mode === "copy-demand" ? (
        <>
          { loading ? null : <img src={CopyDemand} alt="/" />}
          Copy Demand Details
        </>
      ) : mode === "copy-test" ? (
        <>
          { loading ? null : <img src={CopyDemand} alt="/" />}
          Copy Test Details
        </>
      ) : mode === "copy" ? (
        <>
          { loading ? null : <img src={CopyDemand} alt="/" />}
        </>
      ) : mode === "move" ? (
        <>
          { loading ? null : <img src={Save} alt="/" />}
          Move
        </>
      ) : mode === "predefined-type" ? (
        <>
          { loading ? null : <img src={Add} alt="/" /> Add Predefined Type}
        </>
      ) : mode === "ledger-report" ? (
        { loading ? null : <img src={Fetch} alt="/" />}
      ) : mode === "collection-report" ? (
        { loading ? null : <img src={Collected} alt="/" />}
      )  : mode === "grade" ? (
        <>
          {" "}
          { loading ? null : <img src={Grade} alt="/" /> Grade Configuration}
        </>
      ) : mode === "day-end" ? (
        <>
          { loading ? null : <img src={DayEnd} alt="/" />}
          Day End
        </>
      ) : mode === "issue-book" ? (
        <>
          { loading ? null : <img src={BookIssue} alt="/" />}
          Issue Book
        </>
      ) : mode === "return-book" ? (
        <>
          { loading ? null : <img src={BookReturn} alt="/" />}
          Return Book
        </>
      ) : mode === "reserve-book" ? (
        <>
          { loading ? null : <img src={BookReservation} alt="/" />}
          Reserve Book
        </>
      ) : mode === "renewal-book" ? (
        <>
          { loading ? null : <img src={BookRenewal} alt="/" />}
          Renewal Book
        </>
      ) 
       : mode === "sign-out" ? (
        <>Log Out</>
      ) : mode && mode === "make-elligible" ? (
        <>
          { loading ? null : <img src={Save} alt="/" />}
          Make Eligible
        </>
      ) : mode && mode === "preview" ? (
        <>
          { loading ? null : <img src={Preview} alt="/" />}
          Preview
        </>
      ) : mode && mode === "previous" ? (
        <>
          { loading ? null : <img src={Previous} alt="/" />}
          Previous
        </>
      ) : mode && mode === "upload" ? (
        <>
          { loading ? null : <img src={Upload} alt="/" />}
          Upload
        </>
      ) : mode && mode === "collect-fine" ? (
        <>
          { loading ? null : <img src={Received} alt="/" />}
          Collect Fine
        </>
      ) : mode && mode === "waive-off" ? (
        <>
          { loading ? null : <img src={WaiveOff} alt="/" />}
          Waive-Off
        </>
      ) : mode && mode === "add-new-fee" ? (
        <>
          { loading ? null : <img src={AddNewFee} alt="/" />}
        </>
      ) : mode && mode === "all-transaction" ? (
        <>
          { loading ? null : <img src={AllTransaction} alt="/" />}
          All Transaction
        </>
      )  : mode && mode === "show-summarized" ? (
        <>
          { loading ? null : <img src={AllTransaction} alt="/" />}
          Show Summarized
        </>
      ) : mode && mode === "bank-receipts" ? (
        <>
          { loading ? null : <img src={BankReceipts} alt="/" />}
          Bank Receipts
        </>
      ) : mode && mode === "cash-receipts" ? (
        <>
          { loading ? null : <img src={CashReceipts} alt="/" />}
          Cash Receipts
        </>
      ) : mode && mode === "all-receipts" ? (
        <>
          { loading ? null : <img src={AllTransaction} alt="/" />}
          All Receipts
        </>
      ) : mode && mode === "adjustment-receipts" ? (
        <>
          { loading ? null : <img src={AdjustmentReceipts} alt="/" />}
          Adjustment Receipts
        </>
      ) : mode && mode === "extend" ? (
        <>
          { loading ? null : <img src={ExtendCalendar} alt="/" />}
        </>
      ) : mode && mode === "reset" ? (
        <>
          { loading ? null : <img src={Reset} alt="/" />}
        </>
      ) : mode && mode === "re-calculate" ? (
        <>
          { loading ? null : <img src={Recalculate} alt="/" />}
        </>
      )  : mode && mode === "view-graph" ? (
        { loading ? null : <img src={viewgraph} alt="/" />}
      ) : mode && mode === "absent" ? (
        { loading ? null : <img src={Absent} alt="/" />}
      ) : mode && mode === "pay-online" ? (
        <>
          { loading ? null : <img src={PayOnline} alt="/" />}
          Pay Online
        </>
      ) : mode && mode === "user-rights" ? (
        <>
          { loading ? null : <img src={UserRights} alt="/" />}
          Assign Rights
        </>
      ) : mode && mode === "assign-salary-structure" ? (
        <>
          { loading ? null : <img src={Save} alt="/" />}
          Assign Salary Structure
        </>
      )  : mode && mode === "pdf" ? (
        <>
          { loading ? null : <img src={DownloadPdf} alt="/" />}
          Download
        </>
      ) : mode === "pay-fee" ? (
        <>
          { loading ? null : <img src={PayFee} alt="/" />}
          Pay Fee
        </>
      ) : mode === "start-posting" ? (
        <>
          { loading ? null : <img src={Transfer} alt="/" /> Start Posting}
        </>
      ) : mode === "add-depositledgers" ? (
        <>
          { loading ? null : <img src={Add} alt="/" /> Add Deposit Ledgers}
        </>
      ) : mode === "add-doctype" ? (
        <>
          { loading ? null : <img src={Add} alt="/" />}
          Add Document Type
        </>
      ) : mode === "pay-only-ob" ? (
        <>
          { loading ? null : <img src={PayFee} alt="/" />}
          Pay only OB
        </>
      ) : mode === "pay-newdemand-also" ? (
        <>
          { loading ? null : <img src={PayFee} alt="/" />}
          Pay New Balance
        </>
      ) : mode === "close" ? (
        <>
          { loading ? null : <img src={Cancel} alt="/" />}
          Close
        </>
      ) : mode === "docs-upload" ? (
        <>
          Upload
          { loading ? null : <img src={Upload} alt="/" />}
        </>
      ) : mode === "docs-delete" ? (
        <>
          Delete
          { loading ? null : <img src={DeleteButton} alt="/" />}
        </>
      ) : mode === "docs-download" ? (
        <>
          { loading ? null : <img src={Upload} alt="/" />}
          Close
        </>
      ) : null} */}

      {children}
    </button>
  );
};
